import styled from "styled-components"
import { Row, Col, Container } from "react-bootstrap";

import { HoverCardBorder, HoverCardBorderLink } from "../styled/BPSCards";
import { Arrow } from "../styled/Buttons";

import LogoACT from '../../assets/images/Sponsor - ACT.png';
import LogoNBDA from '../../assets/images/Sponsor - NBDA.png';
import LogoPeopleForBikes from '../../assets/images/Sponsor - People for Bikes.png';

import RebateIcon from '../../assets/icons/BPS Icon - Rebate.png';
import ChannelIcon from '../../assets/icons/BPS Icon - Channel Incentives.png';

const Step = styled.div`
    span {
        font-weight: 900;
        font-size: 2rem;
        color: #8DAED7;
        vertical-align: sup;
    }

    .blue-border {
        border-top: 3px solid #8DAED7;
    }

    svg {
        transform: rotate(90deg)!important;
        margin-left: 44%;
        margin-top: -1.5rem;
        fill: #8DAED7;
        height: 48px;
        width: 48px;
    }
    
    p {
        padding: 1rem 0rem 1rem 0rem;
        vertical-align: sub;
    }
`

const PostPurchaseCard = () => {
    return (
        <>
            <Container fluid className="px-0 my-3">
                <Row>
                    <Col>
                        <HoverCardBorder className="p-5">
                            <h3 className='fs-24'>Post-Purchase Programs</h3>
                            <p>
                                Send an incentive directly to consumers after they purchase a qualifying e-bike.
                            </p>
                            <Step>
                                <Row className="justify-content-around align-items-center">
                                    <Col md={1}>
                                        <span>01</span>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Consumer visits a local bike shop and purchases a new e-bike at market value.
                                        </p>
                                    </Col>
                                </Row>
                                <div className="blue-border">
                                    <Arrow />
                                </div>
                            </Step>
                            <Step>
                                <Row className="justify-content-around align-items-center">
                                    <Col md={1}>
                                        <span>02</span>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            After the purchase, the consumer applies online to receive the incentive.
                                        </p>
                                    </Col>
                                </Row>
                                <div className="blue-border">
                                    <Arrow />
                                </div>
                            </Step>
                            <Step>
                                <Row className="justify-content-around align-items-center">
                                    <Col md={1}>
                                        <span>03</span>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Consumer gets reimbursed for their purchase.
                                        </p>
                                    </Col>
                                </Row>
                                <div className="blue-border">
                                    <Arrow />
                                </div>
                            </Step>
                        </HoverCardBorder>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

const PointSalesCard = () => {
    return (
        <>
            <Container fluid className="px-0 py-3">
                <Row>
                    <Col>
                        <HoverCardBorder className="p-5">
                            <h3 className='fs-24'>Point-of-Sales Programs</h3>
                            <p>
                                Offer an instant discount to consumers and reimburse the participating bike shop.
                            </p>
                            <Step>
                                <Row className="justify-content-around align-items-center">
                                    <Col md={1}>
                                        <span>01</span>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Consumer applies for an incentive online.
                                        </p>
                                    </Col>
                                </Row>
                                <div className="blue-border">
                                    <Arrow />
                                </div>
                            </Step>
                            <Step>
                                <Row className="justify-content-around align-items-center">
                                    <Col md={1}>
                                        <span>02</span>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Once approved, consumers visit a local bike shop and purchase a new e-bike. They’ll receive their discount instantly at the time of purchase.
                                        </p>
                                    </Col>
                                </Row>
                                <div className="blue-border">
                                    <Arrow />
                                </div>
                            </Step>
                            <Step>
                                <Row className="justify-content-around align-items-center">
                                    <Col md={1}>
                                        <span>03</span>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            After the sale is complete, the bike shop claims the sale.
                                        </p>
                                    </Col>
                                </Row>
                                <div className="blue-border">
                                    <Arrow />
                                </div>
                            </Step>
                            <Step>
                                <Row className="justify-content-around align-items-center">
                                    <Col md={1}>
                                        <span>04</span>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Once the claim is approved, the bike shop can receive their reimbursement in as little as 24 hours via ACH.
                                        </p>
                                    </Col>
                                </Row>
                                <div className="blue-border">
                                    <Arrow />
                                </div>
                            </Step>
                        </HoverCardBorder>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

const AssociationsCard = () => {
    return (
        <>
            <Container fluid>
                <Row className="justify-content-center">
                    <Col lg={3} sm={4} xs={8} className="py-2">
                        <HoverCardBorderLink className='text-center' href='https://www.peopleforbikes.org/' target='_blank'>
                            <img src={LogoPeopleForBikes} width='100%' alt="People for Bikes" className="d-block" />
                        </HoverCardBorderLink>
                    </Col>
                    <Col lg={3} sm={4} xs={8} className="py-2">
                        <HoverCardBorderLink className='text-center' href='https://www.actweb.org/' target='_blank'>
                            <img src={LogoACT} width='100%' alt="People for Bikes" />
                        </HoverCardBorderLink>
                    </Col>
                    <Col lg={3} sm={4} xs={8} className="py-2">
                        <HoverCardBorderLink className='text-center' href='https://nbda.com/#!event-list' target='_blank'>
                            <img src={LogoNBDA} width='100%' alt="NBDA" />
                        </HoverCardBorderLink>
                    </Col>
                </Row>
            </Container>
        </>
    );
}


export { PostPurchaseCard, PointSalesCard, AssociationsCard }
